exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arrow___arrow___-_cm3 {\n    position: relative;\n    display: inline-block;\n    width: 13px;\n    height: 12px;\n    vertical-align: middle;\n}\n\n.arrow___arrow___-_cm3::before,\n.arrow___arrow___-_cm3::after {\n    position: absolute;\n    content: '';\n}\n\n.arrow___arrow___-_cm3::before {\n    width: 5px;\n    height: 4px;\n    left: 0;\n    top: calc(50% - 2px);\n    background: white;\n}\n\n.arrow___arrow___-_cm3::after {\n    left: 5px;\n    border: 6px solid transparent;\n    border-left: 8px solid white;\n    top: calc(50% - 6px);\n}", ""]);

// exports
exports.locals = {
	"arrow": "arrow___arrow___-_cm3"
};